export enum EnterpriseType {
    CORP = 'CORP',
    MSO = 'MSO'
}
